import { render } from "./ProductDetailPanel.vue?vue&type=template&id=4a19a3c1&scoped=true&ts=true"
import script from "./ProductDetailPanel.vue?vue&type=script&lang=ts"
export * from "./ProductDetailPanel.vue?vue&type=script&lang=ts"

import "./ProductDetailPanel.vue?vue&type=style&index=0&id=4a19a3c1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a19a3c1"]])

export default __exports__